import User from "./User";
import { useNavigate } from "react-router-dom";

export default function UserPageWrapper({ signOut, user }) {
  const navigate = useNavigate(); // Initialize the useNavigate hook to handle navigation

  // Function to navigate to the home page
  const goToHomePage = () => navigate("/");

  // Render the User component, passing down the signOut function, user object, and goToHomePage function as props
  return <User signOut={signOut} user={user} goToHomePage={goToHomePage} />;
}
